import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/src/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/src/layouts/default.vue").then(m => m.default || m)),
  maintenance: defineAsyncComponent(() => import("/src/layouts/maintenance.vue").then(m => m.default || m)),
  member: defineAsyncComponent(() => import("/src/layouts/member.vue").then(m => m.default || m)),
  player: defineAsyncComponent(() => import("/src/layouts/player.vue").then(m => m.default || m))
}